import { useState } from 'react'
import CombinedWizard from '../features/scholarships/CombinedWizard'
import CombinedResultsPage from './CombinedResultsPage'
import { matchScholarships } from '../services/gemini/matcher'
import { SharedProfile, toScholarshipProfile } from '../lib/sharedProfile'
import { MatchedScholarship } from '../features/scholarships/types'

export default function ScholarshipsPage() {
    const [results, setResults] = useState<MatchedScholarship[] | null>(null)
    const [profile, setProfile] = useState<SharedProfile | null>(null)
    const [loading, setLoading] = useState(false)
    const [loadingMessage, setLoadingMessage] = useState('')

    const handleComplete = async (shared: SharedProfile) => {
        setProfile(shared)
        setLoading(true)
        setLoadingMessage('Searching scholarship sources...')

        const t1 = setTimeout(() => setLoadingMessage('Checking your eligibility...'), 4000)
        const t2 = setTimeout(() => setLoadingMessage('Almost done...'), 10000)

        const scholarships = await matchScholarships(toScholarshipProfile(shared))
        clearTimeout(t1)
        clearTimeout(t2)
        setResults(scholarships)
        setLoading(false)
    }

    if (loading) return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-3">
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
            <p className="text-gray-500 text-sm">{loadingMessage}</p>
            <p className="text-gray-400 text-xs">Crawling live scholarship sources — takes ~15 seconds</p>
        </div>
    )

    if (results !== null && profile !== null) return (
        <CombinedResultsPage profile={profile} scholarships={results} />
    )

    return (
        <div className="min-h-screen bg-gray-50 py-12">
            <div className="text-center mb-8">
                <h1 className="text-3xl font-bold">Find Your Funding</h1>
                <p className="text-gray-500 mt-2">
                    See exactly how the OSAP cuts affect you — and what scholarships can close the gap
                </p>
            </div>
            <CombinedWizard onComplete={handleComplete} />
        </div>
    )
}